import ESRI from "./esri";
import Google from "./google";
import Mapbox from "./mapbox";
import Testing from "./testing";

export default { Mapbox, ESRI, Google, Testing };
